import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { useStore } from '../../store/context';

const NewInsuranceStep: FC = observer(() => {
  const { welcomeStore } = useStore();

  const welcomeData = welcomeStore.getWelcomeData();
  const user = welcomeData?.userData;

  const keyValuePairs = [
    {
      key: 'data.PersoenlicheDaten_V1_0.Vorname',
      value: user?.firstname ?? '',
    },
    {
      key: 'data.PersoenlicheDaten_V1_0.Nachname',
      value: user?.lastname ?? '',
    },
    {
      key: 'data.PersoenlicheDaten_V1_0.Email',
      value: user?.email ?? '',
    },
    { key: 'data.PersoenlicheDaten_V1_0.Mobil', value: user?.phone ?? '' },
    { key: 'data.Bankverbindung_V1_0.IBAN', value: user?.iban ?? '' },
  ];

  const baseUrl =
    'https://secure.vav.at/haushaltsversicherung_v13/start.do?id=Haushaltsversicherung_V1_0&affIFrame=ht%E2%80%A6';

  const params = keyValuePairs
    .map(({ key, value }) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = `${baseUrl}&${params}`;
  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Typography variant="h4" sx={{ mt: 2, mb: 2, fontWeight: 'bold' }}>
          Jetzt Prämie berechnen & Wohnung optimal absichern
        </Typography>

        <Typography sx={{ mb: 2 }}>
          Berechnen Sie unverbindlich Ihre individuelle Prämie – ganz ohne
          Verpflichtung. Ihre Daten sind bereits für Sie vorbereitet – ergänzen
          Sie nur noch fehlende Angaben.
        </Typography>

        <Typography sx={{ mb: 2 }}>
          In wenigen Minuten erhalten Sie ein persönliches Angebot – einfach,
          transparent und zu attraktiven Konditionen.
        </Typography>

        <Typography sx={{ mb: 2 }}>
          Ein Vertrag kommt erst zustande, wenn Sie den Antrag am Ende aktiv
          bestätigen.
        </Typography>
      </Box>
      <Box>
        <iframe
          src={url}
          title="Neue Haushaltsversicherung"
          style={{
            width: '100%',
            height: '1250px', // this fits the first page of the form (minus the header) without scrolling
            marginTop: '16px',
            border: 'none',
          }}
        />
      </Box>
    </Box>
  );
});

export default NewInsuranceStep;
